import { Box, Chip, Container, Paper, Stack, Typography } from '@mui/material'

import { Video } from '~ui-components/components/atoms/Video'
import ringEffect from '~ui-components/utilities/ringEffect'
import { CTAButtons } from './CTAButtons'

export function Section1() {
  return (
    <Box
      component={Container}
      py={8}
    >
      <Stack
        spacing={6}
        alignItems='center'
      >
        <Stack
          spacing={4}
          alignItems='center'
        >
          <Chip
            label='Instant geocoder & map maker'
            size='medium'
          />
          <Typography
            component='h1'
            variant='next:h2'
            fontWeight={900}
            textAlign='center'
          >
            {'Location > '}
            <s>{'geocode'}</s>
            {' > interactive map'}
          </Typography>
        </Stack>

        <Typography
          component='p'
          variant='next:h5'
          textAlign='center'
          color='text.secondary'
          maxWidth='88%'
        >
          Turn your location data into full interactive maps in seconds. Skip
          your geocoding process and go straight to impactful map visuals.
        </Typography>

        <CTAButtons />

        <Box
          component={Paper}
          variant='elevation'
          elevation={8}
          sx={(theme) => ({
            width: '100%',
            height: '100%',
            maxHeight: '600px',
            aspectRatio: '16/9',
            borderRadius: 2,
            overflow: 'hidden',
            '&:hover': ringEffect({
              ringColor: theme.palette.primary.main,
              ringWidth: '4px',
              borderRadius: 2
            }),
            '--plyr-color-main': theme.palette.primary.main
          })}
        >
          <Video
            muted
            autoplay
            loop={{
              active: true
            }}
            source={{
              type: 'video',
              sources: [
                {
                  src: `${process.env.NEXT_PUBLIC_MS_ASSETS_URL}/public/videos/sales-demo-2.mp4`,
                  type: 'video/mp4'
                }
              ]
            }}
          />
        </Box>
      </Stack>
    </Box>
  )
}
